import * as React from "react";
const SvgRealEstate = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 14" {...props}>
    <path d="m8.761 3.631-5.76 4.745v5.121a.5.5 0 0 0 .5.5l3.5-.009a.5.5 0 0 0 .498-.5v-2.99a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2.988a.501.501 0 0 0 .5.502l3.5.01a.5.5 0 0 0 .5-.5V8.372L9.24 3.63a.38.38 0 0 0-.478 0Zm9.1 3.225L15.25 4.703V.375A.375.375 0 0 0 14.874 0h-1.75a.375.375 0 0 0-.375.375v2.269L9.952.342a1.5 1.5 0 0 0-1.906 0L.136 6.856a.375.375 0 0 0-.05.528l.797.97a.375.375 0 0 0 .528.05l7.35-6.054a.38.38 0 0 1 .478 0l7.35 6.054a.375.375 0 0 0 .529-.05l.797-.969a.374.374 0 0 0-.053-.529Z" />
  </svg>
);
export default SvgRealEstate;
